import { createSignal } from "solid-js";
import type { SectorValue } from "../context/OnboardingContext";
import { sectorSignature } from "./taxonomy-review-error";

/**
 * The backend's refusal of the sector, kept for the «Settore» card of the
 * review (AC21). A module signal, not a field of the onboarding store:
 * `sector.error` holds the step's own codes and the store is persisted, while
 * this message belongs to one failed request and must not outlive it.
 *
 * It is stored with the signature of the sector that was refused, and the card
 * only shows it while the sector is still that one: changing the sector from
 * any surface (the step, the LinkedIn hub modal) makes it vanish with no effect
 * to clear it. Opening the step clears it too (the route does that).
 */
const [refusal, setRefusal] = createSignal<{
  message: string;
  signature: string;
} | null>(null);

export const reportSectorRefusal = (message: string, sector: SectorValue) => {
  setRefusal({ message, signature: sectorSignature(sector) });
};

export const clearSectorRefusal = () => {
  setRefusal(null);
};

/** The message to show for `sector` now, or `null`. Reactive. */
export const sectorRefusalFor = (sector: SectorValue): string | null => {
  const current = refusal();
  return current && current.signature === sectorSignature(sector)
    ? current.message
    : null;
};
